(function () {
  'use strict';

  /* @ngdoc object
   * @name events.deposits.list
   * @description
   *
   */
  angular
    .module('events.deposits.list', [
      'ui.router'
    ]);
}());
